window.Sparkle = window.Sparkle || {};

(function () {
  // The composers are injected into a modal, so `prepare*` runs against a root that arrives either
  // as a selector, an element, or the jQuery object Modal exposes as `container`.
  function rootElement(target) {
    if (!target) {
      return null;
    }
    if (typeof target === "string") {
      return document.querySelector(target);
    }
    if (target instanceof Element) {
      return target;
    }

    return target[0] || null;
  }

  // Returns the composer's sp-select for `role` once the element is upgraded.
  async function hydrate(root, role) {
    const select = root && root.querySelector(`sp-select[data-role="${role}"]`);
    if (!select) {
      return null;
    }

    await window.customElements.whenDefined("sp-select");

    return select;
  }

  // The template picker applies a template rather than holding a selection, so it clears itself
  // after each pick and falls back to its placeholder icon.
  function onTemplatePick(picker, apply) {
    if (!picker) {
      return;
    }

    picker.addEventListener("input", () => {
      const template = picker.items.find((item) => String(item.value) === String(picker.value));
      if (!template) {
        return;
      }

      apply(template);
      picker.value = "";
    });
  }

  // Mirrors what the delegated update-contenteditable-target behaviour does on focusout, for the
  // scripted edits that never produce one.
  function syncContenteditableTarget(element) {
    const form = element.closest("form");
    const selector = element.dataset.targetSelector;
    const target = selector && form && form.querySelector(selector);

    if (target) {
      target.value = element.innerText;
    }
  }

  window.Sparkle.messageComposer = { rootElement, hydrate, onTemplatePick, syncContenteditableTarget };
})();
